import {
	ChangeDetectorRef,
	Component,
	EventEmitter,
	OnInit,
	Output,
} from '@angular/core';
import { NgForm, FormsModule } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { ApiService } from 'src/app/services/api.services';
import { StepperDetails } from '../register-user.component';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'app-security-question',
	templateUrl: './security-question.component.html',
	styleUrls: [
		'./security-question.component.scss',
		'../../common/main.scss',
		'../register-user.component.scss',
	],
	imports: [
		FormsModule,
		MatFormField,
		MatLabel,
		MatSelect,
		MatOption,
		MatInput,
		MatButton,
	],
})
export class SecurityQuestionComponent implements OnInit {
	@Output() securityQuestion = new EventEmitter<string>();
	@Output() securityAnswer = new EventEmitter<string>();
	@Output() updateStepperDetails = new EventEmitter<StepperDetails>();

	@Output() submitRegisterUserData = new EventEmitter();

	questionsList: string[];

	constructor(
		private readonly stepper: MatStepper,
		private readonly apiService: ApiService,
		private readonly changeDetectorRef: ChangeDetectorRef
	) {
		this.questionsList = [];
	}

	async ngOnInit(): Promise<void> {
		const countryCode = this.getLanguageCountryCodeFromUrl(
			window.location.href
		);
		this.questionsList =
			await this.apiService.getSecurityQuestions(countryCode);
		this.changeDetectorRef.detectChanges();
	}

	getLanguageCountryCodeFromUrl(url: string): string | undefined {
		let countryCode;
		const domainIndex = url.indexOf('.com'); // Find the index of '.com'

		if (domainIndex > -1) {
			const path = url.slice(domainIndex + 4); // Extract the path after '.com'
			const countryCodeCandidate = path.split('/')[1]; // Get the first segment

			if (!countryCodeCandidate.startsWith('register-user')) {
				// if we didn't have the language in the URL for some reason "register-user" would be the start of the first element
				countryCode = countryCodeCandidate;
			}
		}

		return countryCode;
	}

	onNextClicked(f: NgForm): void {
		this.securityQuestion.emit(f.form.value.question);
		this.securityAnswer.emit(f.form.value.answer);
		this.updateStepperDetails.emit({ stepProgress: '100', stepCount: '5' });
		this.submitRegisterUserData.emit(undefined);
		this.stepper.next();
	}

	onBackClicked(): void {
		this.updateStepperDetails.emit({ stepProgress: '50', stepCount: '3' });
		this.stepper.previous();
	}
}
